import { BASE_APP_URL, PROXY_STAGING_URL } from './app';
import { PUBLIC_METAFY_ENV } from '$env/static/public';

const BASE_URL = PUBLIC_METAFY_ENV === 'staging' ? PROXY_STAGING_URL : BASE_APP_URL;

export const DISCORD_CLIENT_ID =
  PUBLIC_METAFY_ENV === 'development'
    ? '590067491510812672'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '772580702713413663'
      : '701323868819816478';
export const DISCORD_AUTH_URL = (type, state) =>
  `https://discordapp.com/api/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/discord/${type}`
  )}&response_type=code&scope=identify+email+guilds.join&state=${state}`;
export const DISCORD_GUILD_AUTH_URL = (type, state) =>
  `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&permissions=268435459&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/discord_guild/${type}`
  )}&scope=bot&state=${state}&integration_type=0&response_type=code`;

export const GOOGLE_CLIENT_ID =
  PUBLIC_METAFY_ENV === 'development'
    ? '323521400191-7m8gnoiim6ph27imf5de9s43tecrivaf.apps.googleusercontent.com'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '183252850709-dbjv7q1ob4gk5oil0v3d34u40t37la4g.apps.googleusercontent.com'
      : '590831099368-s2d37bvur6ufjbqf7c20a545dn6bki8q.apps.googleusercontent.com';
export const GOOGLE_AUTH_URL = (type, state, scope = 'profile email', offline = false) =>
  `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodeURIComponent(scope)}${
    offline ? '&prompt=consent&access_type=offline' : ''
  }&include_granted_scopes=true&response_type=code&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/google/${type}`
  )}&client_id=${GOOGLE_CLIENT_ID}&state=${state}`;

export const TWITCH_CLIENT_ID =
  PUBLIC_METAFY_ENV === 'development'
    ? 'uvssoqjytpw8tstx3x357c81qm2qql'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '5d4dguy1foyr3glzhimbd6tavl2fpy'
      : 'e209xfvhcr1pmz7jd1u43ykm67s6x4';
export const TWITCH_AUTH_URL = (type, state) =>
  `https://id.twitch.tv/oauth2/authorize?client_id=${TWITCH_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/twitch/${type}`
  )}&response_type=code&scope=user:read:email%20user:read:subscriptions&state=${state}`;

export const APPLE_CLIENT_ID = 'gg.metafy.web';
export const APPLE_SCOPES = 'name email';
export const APPLE_REDIRECT = type => `${BASE_URL}/auth/external/apple/${type}`;

export const PATREON_CLIENT_ID =
  PUBLIC_METAFY_ENV !== 'production'
    ? 'rOjgpbk37Oq36waxj-Cj5jU7dy-o_lzTzySiy8LweAojnZhvN4ibchTTiS_1YcTr'
    : '0i-zP4ZcF2SnzT8FZvY39zprKZPkuAR6DjqyyGwBLl0HnjXYPD-P8hh-euwmT-xb';
export const PATREON_AUTH_URL = (type, state) =>
  `https://www.patreon.com/oauth2/authorize?client_id=${PATREON_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/patreon/${type}`
  )}&response_type=code&scope=identity%20identity.memberships%20campaigns%20campaigns.members&state=${state}`;

export const FACEBOOK_CLIENT_ID = PUBLIC_METAFY_ENV === 'development' ? '1192645888013315' : '658925255857857';
export const FACEBOOK_AUTH_URL = (type, state) =>
  `https://www.facebook.com/v15.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    `${BASE_URL}/auth/external/facebook/${type}`
  )}&state=${state}&scope=email`;

export const AVAILABLE_EXTERNALS = {
  discord: 'Discord',
  discord_guild: 'Discord server',
  google: 'Google',
  twitch: 'Twitch',
  apple: 'Apple',
  facebook: 'Facebook',
  patreon: 'Patreon'
};
